define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare,AttributeAction,xml) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.m_id = "RefImageRemove";
			this.m_right = xml.RIGHT_WRITE;
			this.classController = "csi.heading.RefImageRemoveController";
		},

		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: only allow Remove if already referencing image
			return this.inherited(arguments) && xml.isValidURL(this._getValue(ctx));
		}
	});
});